import { ResponsiveText } from '../../ResponsiveText';
import { Subtext, TextContainer, Title } from './WidgetTextSection.styles';

interface WidgetTextSectionProps {
  title: string;
  mobileSubText: string;
  desktopSubText: string;
}

// One <h1> with the same title on every viewport (only its font size changes via CSS); the subtext may differ on mobile
const WidgetTextSection: React.FC<WidgetTextSectionProps> = ({ title, mobileSubText, desktopSubText }) => {
  const hasSubText = !!(desktopSubText || mobileSubText);

  return (
    <TextContainer>
      {title && <Title>{title}</Title>}
      {hasSubText && (
        <Subtext>
          <ResponsiveText desktopText={desktopSubText} mobileText={mobileSubText} />
        </Subtext>
      )}
    </TextContainer>
  );
};

export default WidgetTextSection;
